"use client";

import { type ComponentProps, forwardRef } from "react";
import { cn } from "../../../..";

export interface NativeInputProps extends ComponentProps<"input"> {
	type?: "text" | "email" | "tel" | "url" | "number" | "password";
	isInvalid?: boolean;
}

export const NativeInput = forwardRef<HTMLInputElement, NativeInputProps>(
	function Input(props, ref) {
		const { type = "text", isInvalid, className, ...remainingProps } = props;

		return (
			<input
				ref={ref}
				id={props.id || props.name}
				type={type}
				onWheel={(e) => e.currentTarget.blur()}
				onClick={type === "number" ? (e) => e.currentTarget.select() : undefined}
				{...remainingProps}
				className={cn(
					"form-input w-full rounded bg-white focus:outline-none motion-safe:transition-colors",
					"read-only:cursor-not-allowed read-only:bg-shades-medium-light disabled:cursor-not-allowed disabled:bg-shades-medium-light",
					{
						"border-shades hover:border-primary-medium focus-visible:border-primary-medium focus-visible:ring-primary-medium":
							!isInvalid,
						"border-danger focus-visible:border-danger focus-visible:ring-danger": isInvalid,
					},
					className,
				)}
			/>
		);
	},
);
